import { Injectable, signal, computed, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { translations } from './translations';

export type LanguageCode = 'de' | 'sk' | 'en';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private platformId = Inject(PLATFORM_ID);

  availableLanguages = [
    { code: 'de' as LanguageCode, name: 'Deutsch' },
    { code: 'sk' as LanguageCode, name: 'Slovenčina' },
    { code: 'en' as LanguageCode, name: 'English' },
  ];

  private languageCodeMap: { [key: string]: LanguageCode } = {
    'de': 'de',
    'sk': 'sk',
    'en': 'en'
  };

  private currentLanguageCode = signal<LanguageCode>('de');

  public readonly currentLangCode = this.currentLanguageCode.asReadonly();

  public t = computed(() => translations[this.currentLanguageCode()]);
  public currentLanguageName = computed(() => this.availableLanguages.find(l => l.code === this.currentLanguageCode())?.name || 'Deutsch');

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const storedLang = localStorage.getItem('lang') as LanguageCode;
      if (storedLang && this.availableLanguages.some(l => l.code === storedLang)) {
        this.currentLanguageCode.set(storedLang);
      } else {
        const browserLang = navigator.language.split('-')[0];
        const langCode = this.languageCodeMap[browserLang] || 'de';
        this.currentLanguageCode.set(langCode);
      }
    }
  }

  setLanguage(langCode: LanguageCode): void {
    this.currentLanguageCode.set(langCode);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('lang', langCode);
    }
  }
}
